// Foremost body positions, in meters, measured from the approved GLB transforms.
// Race progress uses the nose; rendering keeps each model's existing origin.
export const CAR_FRONT = Object.freeze({
  ember: 2.5416512489318848,
  thunder: 2.371023416519165,
  eagle: 2.303213119506836,
  venom: 2.489490032196045,
  titan: 2.327115535736084,
});
